<h3 class="text-3 font-bold mt-10 mb-12" *ngIf="data && data.paso && data.paso.descripcion">{{data.paso.descripcion}}</h3>
<h2 class="mat-subheading-2 font-bold">Directorio de Oficinas</h2>
<div class="container mx-auto pb-3 block md:px-0 sm:px-0 lg:px-12">
    <div class="w-full columns-1 w-4/5 mx-auto">
        <mat-accordion class="max-w-4xl mt-8" [multi]="true">
            <ng-container *ngFor="let oficina of directorio;">
                <mat-expansion-panel *ngIf="oficina.value && oficina.label" [expanded]="true">
                    <mat-expansion-panel-header [collapsedHeight]="'56px'" class="md:px0 sm:px0 lg:px-auto">
                        <mat-panel-title class="font-medium leading-tight">{{oficina.value}}</mat-panel-title>
                    </mat-expansion-panel-header>
                    {{oficina.label}}
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </div>
</div>